"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicChannelService = void 0;
var tslib_1 = require("tslib");
var queries_1 = require("./queries");
var mappers_1 = require("./mappers");
var base_public_service_1 = require("../base-public-service");
var guid_1 = require("@wix/wix-vod-shared/dist/src/common/utils/guid");
var mapVideosResp = function (resp) {
    return {
        total: resp.total,
        cursor: resp.cursor,
        items: resp.entities.map(function (video) { return (0, mappers_1.mapGqlPublicVideoToOld)(video); }),
    };
};
var PublicChannelService = /** @class */ (function (_super) {
    tslib_1.__extends(PublicChannelService, _super);
    function PublicChannelService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PublicChannelService.prototype.getChannelVideos = function (opts) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maxLimit, sort, query, tag, category, videosCount, channelId, itemsToLoad, items, total, cursor, limit, videos;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        maxLimit = 20;
                        sort = opts.sort, query = opts.query, tag = opts.tag, category = opts.category, videosCount = opts.videosCount;
                        channelId = (0, guid_1.dashify)(opts.channelId);
                        itemsToLoad = videosCount;
                        items = [];
                        cursor = opts.cursor;
                        _a.label = 1;
                    case 1:
                        if (!(itemsToLoad > 0)) return [3 /*break*/, 3];
                        limit = itemsToLoad < maxLimit ? itemsToLoad : maxLimit;
                        return [4 /*yield*/, this.client.request(queries_1.GET_VIDEOS_QUERY, {
                                channelId: channelId,
                                cursor: cursor,
                                limit: limit,
                                sort: sort,
                                query: query,
                                tag: tag,
                                category: category,
                            })];
                    case 2:
                        videos = (_a.sent()).channel.videos;
                        cursor = videos.cursor;
                        total = videos.total;
                        items = tslib_1.__spreadArray(tslib_1.__spreadArray([], items, true), videos.entities.map(function (video) { return (0, mappers_1.mapGqlPublicVideoToOld)(video); }), true);
                        itemsToLoad = cursor ? itemsToLoad - limit : 0;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, {
                            total: total,
                            cursor: cursor,
                            items: items,
                        }];
                }
            });
        });
    };
    PublicChannelService.prototype.getWidgetData = function (_opts) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var singleVideoId, opts, channel;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        singleVideoId = _opts.singleVideoId, opts = tslib_1.__rest(_opts, ["singleVideoId"]);
                        if (!singleVideoId) return [3 /*break*/, 2];
                        _a = {
                            isSingleVideo: true
                        };
                        return [4 /*yield*/, this.getVideo(singleVideoId)];
                    case 1: return [2 /*return*/, (_a.singleVideo = _b.sent(),
                            _a)];
                    case 2: return [4 /*yield*/, this.client.request(queries_1.GET_WIDGET_DATA_QUERY, opts)];
                    case 3:
                        channel = (_b.sent()).channel;
                        return [2 /*return*/, {
                                isSingleVideo: false,
                                channel: channel ? (0, mappers_1.mapGqlPublicChannelToOld)(channel) : null,
                                videos: mapVideosResp(channel.videos),
                            }];
                }
            });
        });
    };
    PublicChannelService.prototype.getChannel = function (channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp, channel;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_CHANNEL_QUERY, {
                            channelId: (0, guid_1.dashify)(channelId),
                        })];
                    case 1:
                        resp = _a.sent();
                        channel = (0, mappers_1.mapGqlPublicChannelToOld)(resp.channel);
                        return [2 /*return*/, { data: channel }];
                }
            });
        });
    };
    PublicChannelService.prototype.getChannelVideo = function (channelId, videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_CHANNEL_VIDEO_QUERY, {
                            channelId: channelId,
                            videoId: videoId,
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, (0, mappers_1.mapGqlPublicVideoToOld)(resp.channel.video)];
                }
            });
        });
    };
    PublicChannelService.prototype.getVideo = function (videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_VIDEO_QUERY, { videoId: videoId })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, (0, mappers_1.mapGqlPublicVideoToOld)(resp.video)];
                }
            });
        });
    };
    PublicChannelService.prototype.getChannelVideoPlayUrls = function (videoId, channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_CHANNEL_VIDEO_PLAY_URLS_QUERY, {
                            videoId: videoId,
                            channelId: channelId,
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, {
                                'hls.m3u8': resp.channel.video.play.entity.hls,
                            }];
                }
            });
        });
    };
    PublicChannelService.prototype.getChannelTrailerUrl = function (channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resp;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.request(queries_1.GET_CHANNEL_PLAY_URL_QUERY, {
                            channelId: channelId,
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, {
                                'hls.m3u8': resp.channel.play.entity.hls,
                            }];
                }
            });
        });
    };
    return PublicChannelService;
}(base_public_service_1.BasePublicService));
exports.PublicChannelService = PublicChannelService;
//# sourceMappingURL=channel.js.map